import React, { FC } from 'react';

interface Props {
  stockQuantity: number;
  quote: { id: number; quantity?: number; productReference?: any; delivered?: boolean; waitingSupplier?: boolean };
}

const QuoteHardware: FC<Props> = ({ quote, stockQuantity }) => {
  return (
    <li
      className={
        'list-group-item entity-row spaced marked-' + (stockQuantity >= (quote.quantity || 0) ? '' : 'negative')
      }
    >
      <span>{quote.productReference.wording}</span>
      <span className='icon icon-text-document'>{quote.quantity}</span>
      <span className='icon icon-home'>{stockQuantity}</span>
    </li>
  );
};

export default QuoteHardware;
